<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Edit Columns</h4>
    <i
      style="z-index: 1"
      class="bi bi-x-lg text-danger"
      color="warn"
      (click)="onClose()"
      title="Close"
    ></i>
  </div>
  <form>
    <div class="modal-body overflow-auto" style="max-height: 83vh">
      <div class="overflow-y">
        <div>
          <mat-checkbox
            class="example-margin"
            [checked]="selectAllFlag"
            [color]="'primary'"
            (change)="setAll($event.checked, 'selectAll', true)"
          >
            <span class="text-grey"> Select All </span>
          </mat-checkbox>
        </div>
        <div *ngFor="let col of columnsData">
          <mat-checkbox
            class="example-margin"
            [checked]="col.checked"
            [color]="'primary'"
            (change)="setAll($event.checked, col.name, false)"
          >
            <span class="text-grey">
              {{ col.name }}
            </span>
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        (click)="onClose()"
        class="btn btn-outline-secondary"
      >
        Close
      </button>
      <button type="button" (click)="onSubmit()" class="btn btn-primary">
        Apply
      </button>
    </div>
  </form>
</div>
